import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";

export type ConsultingPath =
  | "/security-consultant-in-india"
  | "/perimeter-security-expert-in-india"
  | "/elv-consultant-in-india"
  | "/av-consultant-in-india";

export const CONSULTING_PAGES: { to: ConsultingPath; label: string; text: string }[] = [
  { to: "/security-consultant-in-india", label: "Security Consultant in India", text: "Risk-led planning for CCTV, access control, intrusion and command centres." },
  { to: "/perimeter-security-expert-in-india", label: "Perimeter Security Expert in India", text: "Layered intrusion detection, verification and response at the boundary." },
  { to: "/elv-consultant-in-india", label: "ELV & Building Technology Consultant in India", text: "Security, automation, AV and networks planned together with the building." },
  { to: "/av-consultant-in-india", label: "Audio Visual (AV) Consultant in India", text: "Auditoriums, boardrooms, video conferencing and luxury home cinemas." },
];

/** Compact inline list of related consulting pages, used on solution/about/architect pages. */
export function ConsultingLinks({ intro, only }: { intro: string; only?: ConsultingPath[] }) {
  const items = only ? CONSULTING_PAGES.filter((p) => only.includes(p.to)) : CONSULTING_PAGES;
  return (
    <section aria-label="Related consulting expertise" className="py-12 border-t border-border">
      <div className="container-page">
        <p className="text-sm text-ink-soft max-w-3xl">{intro}</p>
        <ul className="mt-4 flex flex-wrap gap-x-8 gap-y-3 text-sm font-medium">
          {items.map((p) => (
            <li key={p.to}>
              <Link to={p.to} className="tap-target inline-flex items-center gap-1.5 text-primary hover:text-foreground">
                {p.label} <ArrowRight className="h-4 w-4" aria-hidden />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
